import Cookies from "js-cookie";
import PropTypes from "prop-types";
import { Navigate, RouteProps } from "react-router-dom";

import { Env } from "@/config/env";
import { TOKEN_IN_COOKIE } from "@/libs/constants";
import { isMobileDevice } from "@/utils/device-utils";
interface IRouterGuardProps {
  valid?: boolean;
}

// 路由验证
const RouterGuard: React.FC<IRouterGuardProps & RouteProps> = ({
  valid = true,
  element,
}) => {
  if (valid) {
    const daoWorkToken = (window as any).$wujie?.props?.token;

    const token = Cookies.get(TOKEN_IN_COOKIE);

    if (daoWorkToken) {
      Cookies.set(TOKEN_IN_COOKIE, `Bearer ${daoWorkToken}`, {
        domain: Env.DOMAIN,
      });
    } else {
      const pathname = window.location.pathname;

      Cookies.set("RETURE_URL", pathname, {
        domain: Env.DOMAIN,
      });
      if (!token) {
        const redirectUrl = isMobileDevice()
          ? `/signin?returnUrl=${pathname}`
          : `/callback?returnUrl=${pathname}`;

        return <Navigate to={redirectUrl} />;
      }
    }

    return element as React.ReactElement;
  } else {
    return element as React.ReactElement;
  }
};

RouterGuard.propTypes = {
  valid: PropTypes.bool,
  element: PropTypes.node,
};
export { RouterGuard };
